<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<div class="d-flex flex-row mb-5">
						<div class="col-2">
							Generate Dummy Data
						</div>
						<div class="col-6" v-if="$store.getters.canWrite">
							<b-button variant="success" @click="generateSiteDummyData()"><i
								class="fa-solid fa-engine"></i> Generate Dummy Data
							</b-button>
						</div>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
import toastService from "@/services/toastService";
import generalSettingsService from "@/services/generalSettingsService";

export default {
	name: "SiteManagementGeneralSettings",

	methods : {

		generateSiteDummyData(){
			generalSettingsService.generateSiteDummyData(r =>{
					toastService.showSuccessToast("Data Generation Successful");
				},e =>toastService.showErrorToast(e)
			);
		},
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

